import { CSSTransition } from 'react-transition-group';

import {
  enterActiveClassName,
  enterClassName,
  exitActiveClassName,
  exitClassName,
} from './styles';
import { TransitionProps } from './types';

type Props = TransitionProps;

const Transition = ({ children, isVisible, nodeRef }: Props) => {
  return (
    <CSSTransition
      in={isVisible}
      classNames={{
        enter: enterClassName,
        exit: exitClassName,
        enterActive: enterActiveClassName,
        exitActive: exitActiveClassName,
      }}
      timeout={{ enter: 400, exit: 400 }}
      unmountOnExit
      nodeRef={nodeRef}
    >
      {children}
    </CSSTransition>
  );
};

Transition.displyaName = 'Transition';

export default Transition;
